export default __webpack_public_path__ + "i18n/translations/translation-bn.7d8e8d0e.json";